export class ServiceMetaData {
  name: string;
  termsAndConditions: string;
  formattedTermsAndConditions: string;
  youTubeVideoURL: string;
  portalLink: string;
  faq: string;
  digitalNumber: string;
}
